/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to acknowledge escalation
 * @export
 * @interface EscalationAcknowledgeRequest
 */
export interface EscalationAcknowledgeRequest {
    /**
     * Identifier of who acknowledged (e.g. user ID or email)
     * @type {string}
     * @memberof EscalationAcknowledgeRequest
     */
    acknowledgedBy: string;
}

/**
 * Check if a given object implements the EscalationAcknowledgeRequest interface.
 */
export function instanceOfEscalationAcknowledgeRequest(value: object): value is EscalationAcknowledgeRequest {
    if (!('acknowledgedBy' in value) || value['acknowledgedBy'] === undefined) return false;
    return true;
}

export function EscalationAcknowledgeRequestFromJSON(json: any): EscalationAcknowledgeRequest {
    return EscalationAcknowledgeRequestFromJSONTyped(json, false);
}

export function EscalationAcknowledgeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EscalationAcknowledgeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'acknowledgedBy': json['acknowledgedBy'],
    };
}

export function EscalationAcknowledgeRequestToJSON(json: any): EscalationAcknowledgeRequest {
    return EscalationAcknowledgeRequestToJSONTyped(json, false);
}

export function EscalationAcknowledgeRequestToJSONTyped(value?: EscalationAcknowledgeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'acknowledgedBy': value['acknowledgedBy'],
    };
}

